import React, { useState, useEffect } from "react";
import "./loading.css";

const LoadingScreen = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    loading && (
      <div className="loading-screen">
        <img src="https://i.imgur.com/1EBXSNB.png" className="logo-loading" />
      </div>
    )
  );
};

export default LoadingScreen;